// extracted by mini-css-extract-plugin
module.exports = {"root":"MarkdownContent_root__9j4-k"};